import React from 'react';
import { faAward } from '@fortawesome/pro-regular-svg-icons/faAward';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function AwardRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faAward} {...props} />;
}
